import {
    Button,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
  } from "@material-ui/core";
  import React from "react";
  import { makeStyles } from "@material-ui/core/styles";
  
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(3),
    },
    button: {
      margin: theme.spacing(1, 1, 0, 0),
    },
  }));
  
  export default function AgrAccountList(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState("");
    const [isSelected, setIsSelected] = React.useState(true);
    const [isDisabled, setIsDisabled] = React.useState(false);
  
    let options = props.accountListData?.MESSAGE.RESULT[0]?.BODY.options;
  
    const handleRadioChange = (e) => {
      setValue(e.target.value);
      setIsSelected(false);
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      props.onSendAgrWorkflowAccountList(value);
      setIsDisabled(true);
      setIsSelected(true);
    };
  
    return (
      <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
        <form onSubmit={handleSubmit}>
          <Grid item xs>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel component="legend"></FormLabel>
              <RadioGroup
                aria-label="quiz"
                name="quiz"
                value={value}
                onChange={handleRadioChange}
              >
                {options.map((option, i) => (
                  <FormControlLabel
                    key={i}
                    value={isDisabled ? "disabled" : option}
                    disabled={isDisabled}
                    control={<Radio />}
                    label={option}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            className={classes.button}
            disabled={isSelected}
          >
            Submit
          </Button>
        </form>
      </div>
    );
  }
  

// import {
//     Button,
//     FormControl,
//     FormControlLabel,
//     FormLabel,
//     Grid,
//     Radio,
//     RadioGroup,
//   } from "@material-ui/core";
//   import React from "react";
//   import { makeStyles } from "@material-ui/core/styles";
  
//   const useStyles = makeStyles((theme) => ({
//     formControl: {
//       margin: theme.spacing(3),
//     },
//     button: {
//       margin: theme.spacing(1, 1, 0, 0),
//     },
//   }));
  
//   export default function AgrAccountList(props) {
//     console.log("AGR ACCOUNT TRANSACTION REACHED ________________________________________________________________________");
//     debugger
//     const classes = useStyles();
//     const [value, setValue] = React.useState("");
//     const [isSelected, setIsSelected] = React.useState(true);
//     const [isDisabled, setIsDisabled] = React.useState(false);
  
//     let options = props.accountListData[0]?.MESSAGE.RESULT[0]?.BODY.options || [];
  
//     const handleRadioChange = (e) => {
//       setValue(e.target.value);
//       setIsSelected(false);
//     };
  
//     const handleSubmit = (e) => {
//       e.preventDefault();
//       props.onSendWorkflowAccountList(value);
//       setIsDisabled(true);
//       setIsSelected(true);
//     };
  
//     return (
//       <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
//         <form onSubmit={handleSubmit}>
//           <Grid item xs>
//             <FormControl component="fieldset" className={classes.formControl}>
//               <FormLabel component="legend">Account List</FormLabel>
//               <RadioGroup
//                 aria-label="quiz"
//                 name="quiz"
//                 value={value}
//                 onChange={handleRadioChange}
//               >
//                 {options.map((option, i) => (
//                   <FormControlLabel
//                     key={i}
//                     value={isDisabled ? "disabled" : option}
//                     disabled={isDisabled}
//                     control={<Radio />}
//                     label={option}
//                   />
//                 ))}
//               </RadioGroup>
//             </FormControl>
//           </Grid>
//           <Button
//             type="submit"
//             variant="outlined"
//             color="primary"
//             className={classes.button}
//             disabled={isSelected}
//           >
//             Submit
//           </Button>
//         </form>
//       </div>
//     );
//   }
  